<template>
	<div>
		<ui-chips
			v-model="emails"
			:error="emailInvalidText"
			:formatter="validateEmail"
			placeholder="Add e-mail..."
			required
		/>
		<ui-dialog-footer>
			<ui-button
				:disabled="isFetching"
				primary
				text="Send e-mail"
				tooltip="Send e-mail with link to added recipients"
				@click="emails.length > 0 && sendEmail()"
			/>
		</ui-dialog-footer>
	</div>
</template>

<script>
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";
import { isEmail } from "lib/modules/Validate";
import UiButton from "lib/components/ui/Button";
import UiChips from "lib/components/ui/Chips";
import UiDialogFooter from "lib/components/ui/DialogFooter";

export default {
	name: "StreamShareEmail",
	components: {
		UiButton,
		UiChips,
		UiDialogFooter
	},
	props: {
		password: {
			type: String,
			default: "",
			required: false
		},
		streamId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			emails: [],
			emailInvalidText: "",
			isFetching: false
		};
	},
	methods: {
		sendEmail() {
			const parameters = {
				key: this.password,
				lifetime: 4294967295,
				mailto: this.emails
			};

			this.isFetching = true;

			http.post(`/api/v2/recorder/stream/${this.streamId}/share`, parameters)
			.then(() => {
				this.$emit("send");
			})
			.catch((error) => {
				alert.error("Unable to send email", error.response);
			})
			.finally(() => {
				this.isFetching = false;
			});
		},
		validateEmail(email) {
			if (!isEmail(email) && email) { // && email because function runs one more time after enter press with empty string as function arg
				this.emailInvalidText = "Invalid e-mail address";

				return false;
			}

			this.emailInvalidText = "";

			return email;
		}
	}
};
</script>
